import styled from 'styled-components';
import AssureSVG from '../../assets/onboarding/assurance.svg';

const Assurance = styled(AssureSVG as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '4.4rem'};
  height: ${props => props.height || '4.4rem'};
  fill: ${props => props.fill || props.theme.colors.black.base};
`;

export default Assurance;
